import { type ReactNode, useEffect } from "react";
import { ActionLink } from "@hopper-b2b/ui";
import Chevron from "../../../assets/client/arrow-back.svg?react";
import { useBookingSurveyAbandonment } from "../../../hooks/useBookingSurveyAbandonment";
import { useNubankFeatureFlagsContext } from "../../../utils/featureFlagsContext";
import { closeNubankWebview } from "../../../utils/nubankHandoff";
import styles from "./styles.module.scss";

export const FlightSearchMobileHeaderLeftContent = ({
  onClick,
  searchStateStep,
}: {
  className: string;
  onClick: () => void;
  content: ReactNode;
  searchStateStep?: number;
}) => {
  const { enableCsatSurvey } = useNubankFeatureFlagsContext();
  const { tryInterruptAbandonment } = useBookingSurveyAbandonment({
    vertical: "flights",
    enabled: enableCsatSurvey,
  });

  // Slot is placed in: libs/flights/src/modules/search/components/MobileFlightSearchControl/component.tsx
  // searchStateStep -> MobileFlightSearchStep enum value

  const handleGoBack = () => {
    if (searchStateStep === 0) {
      if (tryInterruptAbandonment()) {
        return;
      }
      closeNubankWebview();
      return;
    }

    onClick();
  };

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
  }, []);

  return (
    <ActionLink
      className={styles.FlightSearchMobileHeaderLeftContent}
      content={<Chevron />}
      onClick={handleGoBack}
    />
  );
};
